import { SearchOutlined } from "@ant-design/icons";
import { SearchBar } from "./searchBar";
import { TableColumnType } from "antd";

export const getColumnSearchProps: any = (
  dataIndex: any
): TableColumnType<any> => ({
  filterDropdown: ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
    close,
  }) => (
    <SearchBar
      setSelectedKeys={setSelectedKeys}
      selectedKeys={selectedKeys}
      confirm={confirm}
      clearFilters={clearFilters}
      close={close}
      dataIndex={dataIndex}
    />
  ),
  filterIcon: (filtered: boolean) => (
    <SearchOutlined style={{ color: filtered ? "#1677ff" : undefined }} />
  ),
  onFilter: undefined

});
